export type CotopaxiPaddings = {
  bottom: string;
  left: string;
  right: string;
  top: string;
};

export type CotopaxiBorders = {
  bottom: string;
  top: string;
};

export enum ReactLineStyle {
  DEFAULT = 'default',
  ACCENT = 'accent',
  LIGHT = 'light',
  MEDIUM = 'medium',
}

export enum DividerLineType {
  SINGLE = 'single',
  DOTTED = 'dotted',
  DOUBLE = 'double',
}

export type LineProps = {
  paddings?: CotopaxiPaddings;
  borders?: CotopaxiBorders;
  lineType?: DividerLineType;
  lineStyle?: ReactLineStyle;
};

export interface FixedLengthArray<L extends number, T> extends Array<T> {
  length: L;
}
